import SelectorProvince from './selectorProvince';

export default SelectorProvince;